export const Groups = {
  0: 'serviciosEsenciales',
  1: 'vista',
  2: 'seguridad',
  3: 'calefaccion',
  4: 'vigilancia',
  5: 'adicionales'
};

export const extrasByGroup = {
  serviciosEsenciales: [
    { label: 'abl', name: 'ABL' },
    { label: 'aysa', name: 'AYSA' },
    { label: 'electricidad', name: 'Electricidad' },
    { label: 'gas', name: 'Gas natural' },
    { label: 'internet_wifi', name: 'Internet/Wifi' },
    { label: 'telefono', name: 'Línea telefónica' },
    { label: 'tv_cable', name: 'TV/Cable' }
  ],
  vista: [
    { label: 'abierta', name: 'Abierta' },
    { label: 'calle', name: 'A la calle' },
    { label: 'jardin', name: 'A jardín' },
    { label: 'plaza', name: 'A plaza' },
    { label: 'pulmonManzana', name: 'A pulmón de manzana' }
  ],
  seguridad: [
    { label: 'alarma', name: 'Alarma en la propiedad' },
    { label: 'grupoElectrogeno', name: 'Grupo electrógeno' },
    { label: 'puertaBlindada', name: 'Puerta blindada' }
  ],
  calefaccion: [
    { label: 'aireAcondicionado', name: 'Aire acondicionado' },
    { label: 'caldera_central', name: 'Caldera (central)' },
    { label: 'caldera_individual', name: 'Caldera (individual)' },
    { label: 'calefaccion_central', name: 'Calefacción (central)' },
    { label: 'calefaccion_estufa_gas', name: 'Calefacción (estufa a gas)' },
    { label: 'calefaccion_losa_central', name: 'Calefacción (losa central)' },
    {
      label: 'calefaccion_losa_individual',
      name: 'Calefacción (losa individual)'
    },
    {
      label: 'calefaccion_placas_bajo_consumo',
      name: 'Calefacción (placas bajo consumo)'
    },
    {
      label: 'calefaccion_radiadores_central',
      name: 'Calefacción (radiadores central)'
    },
    {
      label: 'calefaccion_radiadores_individual',
      name: 'Calefacción (radiadores individuales)'
    },
    { label: 'chimenea', name: 'Chimenea' },
    { label: 'split', name: 'Split frío/calor' },
    { label: 'termotanque_calefon', name: 'Termotanque/Calefón' },
    { label: 'ventilador', name: 'Ventilador de techo' }
  ],
  vigilancia: [
    { label: 'camaras', name: 'Cámaras de seguridad' },
    { label: 'encargado', name: 'Encargado' },
    { label: 'encargado_virtual', name: 'Encargado (virtual/pantalla)' },
    { label: 'portero_electrico', name: 'Portero eléctrico' },
    { label: 'vigilancia_24hs', name: 'Vigilancia (24hs)' },
    { label: 'vigilancia_diurna', name: 'Vigilancia (diurna)' },
    { label: 'vigilancia_fin_de_semana', name: 'Vigilancia (fin de semana)' },
    { label: 'vigilancia_nocturna', name: 'Vigilancia (nocturna)' }
  ],
  adicionales: [
    { label: 'amoblado', name: 'Amoblado' },
    { label: 'cancha_paddle', name: 'Cancha de paddle' },
    { label: 'cancha_tenis', name: 'Cancha de tenis' },
    {
      label: 'centros_comerciales_cercanos',
      name: 'Centros comerciales cercanos'
    },
    { label: 'cocina_electrica', name: 'Cocina (eléctrica)' },
    { label: 'cocina_gas', name: 'Cocina (gas)' },
    { label: 'escuelas_cercanas', name: 'Escuelas cercanas' },
    { label: 'estacionamiento_visitas', name: 'Estacionamiento de visitas' },
    { label: 'gimnasio', name: 'Gimnasio' },
    { label: 'hidromasaje', name: 'Hidromasaje' },
    { label: 'laundry', name: 'Laundry' },
    { label: 'microcine', name: 'Microcine' },
    { label: 'parques_cercanos', name: 'Parques cercanos' },
    { label: 'parrilla', name: 'Parrilla' },
    { label: 'piscina', name: 'Piscina' },
    { label: 'placards', name: 'Placards' },
    { label: 'sala_de_juegos', name: 'Sala de juegos' },
    { label: 'sauna', name: 'Sauna' },
    { label: 'solarium', name: 'Solarium' },
    { label: 'spa', name: 'Spa' },
    { label: 'sum', name: 'SUM' },
    { label: 'termotanque_electrico', name: 'Termotanque (eléctrico)' },
    { label: 'termotanque_gas', name: 'Termotanque (gas)' }
  ]
};

const totalExtras = [
  ...extrasByGroup.serviciosEsenciales,
  ...extrasByGroup.vista,
  ...extrasByGroup.seguridad,
  ...extrasByGroup.calefaccion,
  ...extrasByGroup.vigilancia,
  ...extrasByGroup.adicionales
];

export const allExtras = totalExtras.map(extra => extra.label);

export const extrasByProperty = {
  0: allExtras,
  1: allExtras,
  2: allExtras,
  3: allExtras,
  4: [],
  5: allExtras,
  6: allExtras,
  7: allExtras,
  8: allExtras,
  9: allExtras,
  10: [],
  11: allExtras,
  12: allExtras,
  13: []
};
